/* eslint-disable indent */
import { contain } from 'react-container-helper';
import { connect } from 'react-redux';

import { normalizePathname } from 'util/path';

import HeaderHotel from './component';

const initState = () => ({
	isSideNaviOpened: false,
	fixNav: false,
	imageHeight: 0,
});

const mapSetStateToProps = (
	{ isSideNaviOpened, fixNav, imageHeight },
	{ lan, hotel, hotelData, ...props },
	setState,
) => ({
	// states
	isSideNaviOpened,
	fixNav,
	lan,
	hotel,
	bannerText: hotelData[hotel].name,

	// redux data
	...props,

	// actions
	toggleNavi() {
		setState({ isSideNaviOpened: !isSideNaviOpened });
	},
	closeNavi() {
		setState({ isSideNaviOpened: false });
	},
	onClickOutside(e) {
		// prevent close navi when clicking hambuger
		if (e.clientY > 80 || e.clientX > 45) {
			setState({ isSideNaviOpened: false });
		}
	},
	getImageHeight(height) {
		if (imageHeight !== height) {
			setState({ imageHeight: height });
		}
	},
	bookHotel() {
		let bookingLink = '';
		if (hotel === 'osakaShinsaibashi') {
			bookingLink = `https://member.silkshotelgroup.com/${lan}/JSOKS`;
			// const curr = langStr => {
			//	const str = {
			//		'zh-TW': 'TWD',
			//		'zh-CN': 'CNY',
			//		'ja': 'JPY',
			//		'ko': 'KRW',
			//		'en': 'USD'
			//	}
			//	return str[langStr];
			// };

			// bookingLink = `https://book-directonline.com/properties/jsosdirect?locale=
			// ${lan}&currency=${curr(lan)}`;
		} else {
			const lang = langStr => {
				let str = '';
				switch (langStr) {
					case 'zh-TW':
						str = null;
						break;
					case 'zh-CN':
						str = 'zh-CN';
						break;
					case 'ja':
						str = 'ja';
						break;
					case 'ko':
						str = 'ko';
						break;
					default:
						str = 'en';
						break;
				}
				return str ? `${str}/` : '';
			};
			bookingLink = `https://member.silkshotelgroup.com/${lang(lan)}${
				hotelData[hotel].bookingCode
			}`;
		}
		window.open(bookingLink, '_blank');
	},
});

const setLifecycle = () => ({
	componentWillReceiveProps({ pageYOffset }, { getState, getProps, setState }) {
		const { imageHeight } = getState();
		const { pageYOffset: previousPageYOffset } = getProps();

		if (pageYOffset !== previousPageYOffset) {
			setState({ previousPageYOffset: pageYOffset });

			if (pageYOffset > imageHeight - 80) {
				setState({ fixNav: true });
			} else {
				setState({ fixNav: false });
			}
		}
	},
});

const componentContainer = contain(initState, mapSetStateToProps, setLifecycle)(HeaderHotel);

const getPage = pathname => {
	const pathnames = normalizePathname(pathname);

	return pathnames.length <= 3 || !pathnames[3] ? '' : pathnames[3];
};

const mapStateToProps = ({
	global: {
		window: { media, pageYOffset },
		lan,
	},
	routing: {
		locationBeforeTransitions: { pathname },
	},
	hotel: { hotel, hotelData },
	banner: { image, thumbnail },
}) => ({
	media,
	hotel,
	hotelData,
	lan,
	page: getPage(pathname),
	pageYOffset,
	bannerImage: image,
	bannerThumbnail: thumbnail,
});

export default connect(mapStateToProps)(componentContainer);



// WEBPACK FOOTER //
// ./src/components/organisms/HeaderHotel/index.js